import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiLoadingService {
  private _isAnyApiLoading$ = new BehaviorSubject<boolean>(false);
  private _loadingComponents = new Set<string>();

  /**
   * Register a component as loading
   * @param componentName - Name of the component (e.g., 'chart', 'table', 'overview')
   */
  setLoading(componentName: string): void {
    this._loadingComponents.add(componentName);
    this._isAnyApiLoading$.next(true);
  }

  /**
   * Unregister a component as loading
   * @param componentName - Name of the component
   */
  setNotLoading(componentName: string): void {
    this._loadingComponents.delete(componentName);
    this._isAnyApiLoading$.next(this._loadingComponents.size > 0);
  }

  /**
   * Check if any component is currently loading
   */
  isAnyApiLoading(): boolean {
    return this._loadingComponents.size > 0;
  }

  /**
   * Get observable for loading state
   */
  getLoadingState(): BehaviorSubject<boolean> {
    return this._isAnyApiLoading$;
  }

  /**
   * Clear all loading states (useful for error handling)
   */
  clearAllLoading(): void {
    this._loadingComponents.clear();
    this._isAnyApiLoading$.next(false);
  }

  /**
   * Check if a specific component is loading
   */
  isComponentLoading(componentName: string): boolean {
    return this._loadingComponents.has(componentName);
  }
}
